import { useQuery } from '@hooks/reactQuery';

import { getGoldenSettingsOnSelectedDate } from '@api/goldenSettings';

import { handleErrorFromMessage } from '@utils/handleRequestError';
import { startOfDayInUTC } from '@utils/kpi-utils/date';

import { IGoldenSettingsOnSelectedDateDTO } from '@interfaces/cmModule/dto/goldenSettingsDTO';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { EErrorCodes } from '@enums/errorCodes';

import { refetchOptions } from '@constants/common';
import { GOLDEN_SETTING_ON_SELECTED_DATE } from '@constants/queryKeys';

interface IUseQueryGoldenSettingsOnSelectedDateReturnType {
	goldenSettingsOnSelectedDate?: string;
	isLoadingGoldenSettingsOnSelectedDate: boolean;
}

const useQueryGoldenSettingsOnSelectedDate = (
	params: IGoldenSettingsOnSelectedDateDTO,
): IUseQueryGoldenSettingsOnSelectedDateReturnType => {
	const {
		vendor,
		technology,
		nodeType,
		siteId,
		date,
	} = params;

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [GOLDEN_SETTING_ON_SELECTED_DATE, vendor, technology, nodeType, siteId, date],
		queryFn: async () => {
			if (siteId && date)
				return getGoldenSettingsOnSelectedDate({
					siteId,
					date: startOfDayInUTC(new Date(date)),
					vendor,
					technology: technology!,
					nodeType: nodeType!,
				});
		},
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => item.code === EErrorCodes.goldenSettingsNotSet)) {
				handleErrorFromMessage(err);
			}
		},
		enabled: [siteId, date, vendor, technology, nodeType],
		...refetchOptions,
	});

	return {
		goldenSettingsOnSelectedDate: data,
		isLoadingGoldenSettingsOnSelectedDate: (isLoading && !!data) || isFetching,
	};
};

export default useQueryGoldenSettingsOnSelectedDate;
